import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { Drawer, DrawerOverlay, DrawerContent, Box, DrawerHeader, DrawerCloseButton, DrawerBody, DrawerFooter, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Modal as Modal$1, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } from '@chakra-ui/react';
import Button from '../Button/component.js';
import { ButtonVariant } from '../Button/types.js';

var Modal = function Modal(_ref) {
  var id = _ref.id,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? 'modal' : _ref$modalType,
      header = _ref.header,
      footer = _ref.footer,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$drawerPlacement = _ref.drawerPlacement,
      drawerPlacement = _ref$drawerPlacement === void 0 ? 'left' : _ref$drawerPlacement,
      variant = _ref.variant,
      isCentered = _ref.isCentered,
      children = _ref.children,
      isDestructive = _ref.isDestructive,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'Close' : _ref$closeLabel,
      actionLabel = _ref.actionLabel,
      actionOnClick = _ref.actionOnClick,
      className = _ref.className,
      _ref$containerRef = _ref.containerRef,
      containerRef = _ref$containerRef === void 0 ? undefined : _ref$containerRef;
  /**
   * Methods
   */

  var handleOnClose = useCallback(function () {
    if (!onClose) {
      return;
    }

    onClose();
  }, [onClose]);
  var actionButtonRef = React.useRef(null);
  /**
   * DOM
   */

  if (modalType === 'drawer') {
    return /*#__PURE__*/React.createElement(Drawer, {
      variant: variant,
      id: id,
      isOpen: isOpen,
      onClose: handleOnClose,
      size: size,
      placement: drawerPlacement
    }, /*#__PURE__*/React.createElement(DrawerOverlay, null), /*#__PURE__*/React.createElement(DrawerContent, null, !!header && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(DrawerHeader, {
      "data-object-type": "core-drawer-header"
    }, header)), !!showCloseButton && /*#__PURE__*/React.createElement(DrawerCloseButton, {
      "data-object-type": "core-drawer-close-button"
    }), /*#__PURE__*/React.createElement(DrawerBody, {
      "data-object-type": "core-drawer-body"
    }, children), !!footer && /*#__PURE__*/React.createElement(DrawerFooter, {
      "data-object-type": "core-drawer-footer"
    }, footer)));
  }

  if (modalType === 'alert') {
    return /*#__PURE__*/React.createElement(AlertDialog, {
      closeOnOverlayClick: false,
      isCentered: true,
      size: 'md',
      id: id,
      isOpen: isOpen,
      onClose: handleOnClose,
      leastDestructiveRef: actionButtonRef
    }, /*#__PURE__*/React.createElement(AlertDialogOverlay, null), /*#__PURE__*/React.createElement(AlertDialogContent, null, !!header && /*#__PURE__*/React.createElement(AlertDialogHeader, {
      "data-testid": "core-modal-header"
    }, header), /*#__PURE__*/React.createElement(AlertDialogBody, {
      "data-testid": "core-modal-body"
    }, children), /*#__PURE__*/React.createElement(AlertDialogFooter, {
      "data-testid": "core-modal-footer"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.SOLID,
      colorScheme: 'gray',
      onClick: onClose,
      ref: actionButtonRef
    }, closeLabel), !!actionLabel && /*#__PURE__*/React.createElement(Button, {
      variant: ButtonVariant.SOLID,
      colorScheme: isDestructive ? 'error' : 'brand',
      onClick: isDestructive ? actionOnClick : actionOnClick || onClose
    }, actionLabel))));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal$1, _extends({
    variant: variant,
    id: id,
    isOpen: isOpen,
    onClose: handleOnClose,
    size: size,
    motionPreset: 'none',
    portalProps: {
      containerRef: containerRef
    }
  }, isCentered === true && {
    blockScrollOnMount: true,
    scrollBehavior: 'inside'
  }), /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, {
    className: className
  }, !!header && /*#__PURE__*/React.createElement(ModalHeader, {
    "data-testid": "core-modal-header"
  }, header), showCloseButton && /*#__PURE__*/React.createElement(ModalCloseButton, {
    "data-testid": "core-drawer-modal-button"
  }), /*#__PURE__*/React.createElement(ModalBody, {
    "data-testid": "core-modal-body"
  }, children), !!footer && /*#__PURE__*/React.createElement(ModalFooter, {
    "data-testid": "core-modal-footer"
  }, footer))));
};

export { Modal };